/* BLUE CALENDAR — MARVI OCEAN
   Full species dataset. Sources: NOAA Fisheries, IUCN Red List, WWF, IWC, national agencies.
   REBUILD NOTES (2026-07): full 41-species dataset restored (humpback split into 6 populations,
   blue/fin/gray/minke/sei/sperm whales, right whales, bowhead, common dolphin, orcas, whale sharks,
   sea turtles, great white shark, sardine run, manta rays). oceanEvents restored.
   Species data is split across assets/bc-data-part1.js..part6.js (loaded before this file via
   script tags in sections/blue-calendar.liquid) purely to keep each upload chunk a manageable size;
   this file just concatenates them into the single window.BC_DATA object the renderer expects.
*/
window.BC_DATA = {
  monthNames: ["January","February","March","April","May","June","July","August","September","October","November","December"],

  species: [].concat(
    window.BC_DATA_PART1 || [],
    window.BC_DATA_PART2 || [],
    window.BC_DATA_PART3 || [],
    window.BC_DATA_PART4 || [],
    window.BC_DATA_PART5 || [],
    window.BC_DATA_PART6 || []
  ),

  oceanEvents: [
    { monthIdx: 1, emoji: "🦚", title: "Coral spawning (GBR pre-season)", note: "Some southern GBR reef sections begin spawning into early year; check GBR Marine Park Authority for lunar-linked dates." },
    { monthIdx: 4, emoji: "🦑", title: "Giant cuttlefish breeding begins (Whyalla, SA)", note: "Numbers build toward the peak winter aggregation." },
    { monthIdx: 5, emoji: "🐟", title: "Sardine Run begins (South Africa)", note: "Billions of sardines begin moving north up the KwaZulu-Natal coast." },
    { monthIdx: 5, emoji: "🐢", title: "Green turtle nesting peaks (Tortuguero, Costa Rica)", note: "Main nesting season in full swing." },
    { monthIdx: 7, emoji: "🪸", title: "Jellyfish blooms (Mediterranean & SE Asia)", note: "Warm late-summer water brings seasonal blooms in multiple regions. Timing and species vary by location." },
    { monthIdx: 8, emoji: "🐢", title: "Olive ridley arribada (Ostional, Costa Rica)", note: "Synchronised mass nesting events; peak Sep–Nov." },
    { monthIdx: 9, emoji: "🐧", title: "Penguin breeding season begins (Southern Hemisphere)", note: "Many Southern Hemisphere penguins begin courtship around local spring. Timing varies by species." },
    { monthIdx: 10, emoji: "🦚", title: "Mass coral spawning (GBR, main event)", note: "The GBR’s largest annual spawning event, triggered a few nights after the October or November full moon. Announced by reef authorities closer to the date." },
    { monthIdx: 10, emoji: "🦈", title: "Shark aggregations increase (multiple regions)", note: "Several shark species show seasonal aggregation behaviour this time of year across different regions." },
    { monthIdx: 11, emoji: "🐢", title: "Sea turtle hatchlings emerging (Costa Rica)", note: "Nests from the mid-year peak begin hatching roughly 45–70 days after laying." }
  ],

  monthlyHighlights: {}
};

window.BC_DATA_LOADED = true;
